import {
  defineClientEnv,
  httpUrl,
  nonEmpty,
} from '@up2stay/up2promo-commons/env';

/** Public build env of the setup frontend (ADR-0029). Keep `.env.example` in sync. */
export const envSchema = defineClientEnv({
  /** API origin, no `/api/v1` (the SDK paths include it). */
  VITE_API_URL: { schema: httpUrl(), required: 'build' },
  VITE_POSTHOG_KEY: { schema: nonEmpty(), required: 'deployed' },
  VITE_POSTHOG_HOST: { schema: httpUrl(), required: 'optional' },
});
